export default {
  computed: {
    loggedIn() {
      return this.$auth ? this.$auth.Token : false;
    },
  },
  mounted() {
    if (this.loggedIn && process.client) {
      window.location.href = this.localePath("/account/billing-plan");
    }
  },
};
